var version = '6.5.1';

module.exports = version;
